import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import {Inject, Injectable, PLATFORM_ID} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RedirectUrlService {

  constructor(@Inject(DOCUMENT) private _doc: Document, @Inject(PLATFORM_ID) private readonly platformId: any) {}

  getQueryParameterByName(url = this.getWindow()?.location.href) : string | null {
    if (!url) {
      url = this.getWindow()?.location.href ?? '';
    }
    const parsedUrl = this.processUrl(url);
    let fullURL : string;
    if(parsedUrl) {
      if(parsedUrl.search && parsedUrl.hash) {
        // Include pathname, search (query params), and hash
        fullURL = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      } else if(parsedUrl.search) {
        // Include pathname and search (query params)
        fullURL = parsedUrl.pathname + parsedUrl.search;
      } else if(parsedUrl.hash) {
        // Include pathname and hash
        fullURL = parsedUrl.pathname + parsedUrl.hash;
      } else {
        // Just pathname
        fullURL = parsedUrl.pathname;
      }
      return encodeURIComponent(fullURL);
    }
    return null;
  }

  processUrl(originalUrl: string) : URL | null {
    try {
      return new URL(originalUrl, this.getWindow()?.location.origin);
    } catch (error) {
      return null;
    }
  }

  getWindow(): Window | null {
    return this.isBrowser() ? window : this._doc.defaultView;
  }

  isBrowser = () => isPlatformBrowser(this.platformId);

  nativeWindow() {
    if (isPlatformBrowser(this.platformId)) {
      return window;
    } else {
      return null;
    }
  }

}
